import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  asset: belongsTo('asset', { inverse: null }),
  newsletterTarget: belongsTo('newsletter-target', { inverse: null }),
});
